import React from 'react';
import CustomAccordion from '../ui/CustomAccordion';
import DeduplicationTable from '../Table/DeduplicationTable';
import { DeduplicationMatch } from '../types';

interface FieldConfig {
  id: string;
  name: string;
  displayName: string;
  fields: {
    ExpandedViewItemKey: { value: string };
    ExpandedViewItemLabel: { value: string };
  };
}

interface DeduplicationSectionProps {
  enrichedDeduplicationData?: DeduplicationMatch[];
  expanded: boolean;
  onExpandChange: () => void;
  onOpenMergeModal?: (match: DeduplicationMatch) => void;
  rowData?: {
    phone?: string;
    deduplication?: DeduplicationMatch[];
  };
  fieldConfigs?: FieldConfig[];
  headerText?: string;
}

const DeduplicationSection: React.FC<DeduplicationSectionProps> = ({
  enrichedDeduplicationData,
  expanded,
  onExpandChange,
  onOpenMergeModal,
  rowData,
  fieldConfigs,
  headerText,
}) => {
  if (
    !enrichedDeduplicationData ||
    enrichedDeduplicationData.length === 0 ||
    fieldConfigs?.length === 0
  )
    return null;

  return (
    <CustomAccordion
      title={headerText || 'Deduplication Additional Parameters'}
      expanded={expanded}
      onChange={onExpandChange}
      sx={{
        my: 1,
        boxShadow: 'none',
        border: '1px solid #E9E9E9',
        '&:before': { display: 'none' },
        '& .MuiAccordionSummary-root': { minHeight: '40px', py: 0.5 },
        '& .MuiAccordionSummary-root.Mui-expanded': { minHeight: '40px', py: 0.5 },
        '& .MuiAccordionSummary-content': { margin: '0 !important' },
        '& .MuiAccordionSummary-content.Mui-expanded': { margin: '0 !important' },
      }}
      summarySx={{
        backgroundColor: '#F6F7FB',
        fontWeight: 600,
      }}
      detailsSx={{ p: 0 }}
    >
      <DeduplicationTable
        deduplicationMatches={enrichedDeduplicationData}
        onOpenMergeModal={onOpenMergeModal}
        hideSelectColumn={true}
        parentData={{
          phoneNumber: rowData?.phone,
          deduplication: enrichedDeduplicationData,
        }}
        fieldConfig={
          fieldConfigs
            ? fieldConfigs.map((val) => ({
                key: val.fields.ExpandedViewItemKey.value,
                label: val.fields.ExpandedViewItemLabel.value,
              }))
            : undefined
        }
      />
    </CustomAccordion>
  );
};

export default DeduplicationSection;
